//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const AllowHtmlScripts: FeatureFlag = {"Id":"AllowHtmlScripts","Label":"(KILL)[10.24]AllowHtmlScripts","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, script elements in HTML content blocks, calculated display fields, the site footer, the home page content area, the Not Found page, and the Error page are executed by the browser.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
